import React from 'react';

export const Wordmark = ({ size = 72, color, stacked = false }) => {
  const base = {
    fontFamily: 'var(--fw-sans)',
    fontWeight: 800,
    letterSpacing: '-0.04em',
    lineHeight: 0.88,
    fontSize: size,
    color: color || 'var(--fw-ink)',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  };
  if (stacked) {
    return (
      <span style={base}>
        bboy<span style={{ color: 'var(--fw-red)' }}>/</span>
        <br />creative
      </span>
    );
  }
  return (
    <span style={base}>
      bboy<span style={{ color: 'var(--fw-red)' }}>/</span>creative
    </span>
  );
};

export const WordmarkProse = ({ size = 20, color }) => (
  <span style={{
    fontFamily: 'var(--fw-sans)',
    fontWeight: 800,
    letterSpacing: '-0.02em',
    lineHeight: 1,
    fontSize: size,
    color: color || 'var(--fw-ink)',
    whiteSpace: 'nowrap',
  }}>
    bboy creative
  </span>
);

export const Mark = ({ size = 32, color = 'var(--fw-ink)', bg = 'transparent' }) => (
  <div style={{
    width: size, height: size, background: bg,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: 'var(--fw-sans)', fontWeight: 800,
    fontSize: size * 0.5, letterSpacing: -1.5,
    color, lineHeight: 1,
  }}>
    b<span style={{ color: 'var(--fw-red)' }}>/</span>c
  </div>
);

export const MetaLabel = ({ children, color, size = 11 }) => (
  <span style={{
    fontFamily: 'var(--fw-mono)',
    fontSize: size,
    letterSpacing: '1.4px',
    textTransform: 'uppercase',
    color: color || 'var(--fw-muted)',
  }}>{children}</span>
);

export const Tagline = ({ color, size = 14 }) => (
  <span style={{
    fontFamily: 'var(--fw-serif)',
    fontStyle: 'italic',
    fontWeight: 400,
    fontSize: size,
    color: color || 'var(--fw-ink)',
    letterSpacing: '-0.01em',
  }}>
    Stylish Software.
  </span>
);

export const CornerTick = ({ pos, color = 'var(--fw-ink)' }) => {
  const base = { position: 'absolute', width: 12, height: 12, pointerEvents: 'none' };
  const borders = {
    tl: { top: 0, left: 0, borderTop: `1.5px solid ${color}`, borderLeft: `1.5px solid ${color}` },
    tr: { top: 0, right: 0, borderTop: `1.5px solid ${color}`, borderRight: `1.5px solid ${color}` },
    bl: { bottom: 0, left: 0, borderBottom: `1.5px solid ${color}`, borderLeft: `1.5px solid ${color}` },
    br: { bottom: 0, right: 0, borderBottom: `1.5px solid ${color}`, borderRight: `1.5px solid ${color}` },
  };
  return <span style={{ ...base, ...borders[pos] }} />;
};
